import React from 'react';

import css from './PasswordValidation.module.scss';

interface Props {
  isValid: boolean;
  isError?: boolean;
  label: string;
  dataTestIdPassed?: string;
  dataTestIdFailed?: string;
}

const PasswordValidation = ({
  isValid,
  isError,
  label,
  dataTestIdPassed,
  dataTestIdFailed
}: Props) => {
  const passedClassName = css.passwordValidationPassed;
  const failedClassname = css.passwordValidationFailed;

  return (
    <div
      className={`${css.passwordValidation} ${isValid ? passedClassName : ''} ${
        isError ? failedClassname : ''
      }`}
      data-testid={isValid ? dataTestIdPassed : dataTestIdFailed}
    >
      <svg
        width="11"
        height="11"
        viewBox="0 0 11 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.83333 5.51772L4.34489 8.02928L9.16666 3.20834"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>

      <p>{label}</p>
    </div>
  );
};

export default PasswordValidation;
